/**
 * Query to fetch typologies associated with a seller
 */
const sellerTypologiesQuery = `
query GetSellerTypologies($sellerId: ID!) {
  marketplace_seller(id: $sellerId) {
    objectId
    typologies {
      edges {
        node {
          objectId
          name
          b2b
          b2c
          icon {
            url
          }
          cover {
            url
          }
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default sellerTypologiesQuery;
